<!--  -->
<template>
    <div>
        <my-header :title="resource.title" :is-back="true"/>
        <div class="article-wrap">
            <div class="title">{{item.title}}</div>
            <div class="author">{{item.author}}</div>
            <article class="content" v-html="item.content"></article>
        </div>

        <div class="wrap-box">
            <!-- 点赞、评论、收藏、转发 -->
            <action-bar/>
            <!-- 评论区 -->
            <van-divider/>
            <subtitle title="评论"/>
            <comment-list :item-id="item.id"/>
        </div>
    </div>
</template>

<script>
import LoadResource from "@/views/resource/LoadResource";
import MyHeader from "@/components/myHeader";
import ActionBar from "@/components/actionBar";
import Subtitle from "@/components/subtitle";
import CommentList from "@/components/commentList";
import {computed} from "vue";
import AddPointMixin from "@/views/resource/AddPointMixin";

export default {
    name: "index",
    components:{CommentList, Subtitle, ActionBar, MyHeader},
    mixins:[AddPointMixin],
    props:{
        id:{
            type:String,
            required:true,
        }
    },
    watch:{
        id(val){
            this.initLoadResource(val,true)
        }
    },
    provide(){
        return{
            resourceId:computed(() => this.resource.id),
            resourceItemId:computed(() => this.item.id),
            enableComment:computed(() =>  this.resource.enableComment)
        }
    },
    setup(props){
        const obj = new LoadResource(props.id,true)
        const initLoadResource = (id,fetchContent) => obj.init(id,fetchContent);
        const loadResource = () => obj.loadResource();

        return{
            // 服务端响应数据
            resource:obj.resource,
            // 加载数据中
            loading:obj.loading,
            // 初始化，重新加载数据
            initLoadResource,
            // 加载数据
            loadResource,
        }
    },
    computed:{
        item(){
            return this.resource.firstItem || {}
        }
    }
}
</script>

<style scoped>
.article-wrap,.wrap-box{
    padding: 20px;
}
.title{
    text-align: center;
    font-size: 1.2rem;
    font-weight: bold;
}
.author{
    font-size: 0.9rem;
    color: #4E4E4E;
    text-align: center;
}
</style>
